import Model from './Model';

let EventHandlers = function() {
  console.log('EventHandlers');
  $('.kBtn').click(function() {
    let thisBtn = $(this);
    let kId = thisBtn.closest('.courseContainer ').attr('data-kId');
    console.log('kId:' + kId);
    let gotoUrl = null;
    let openLink = false;
    if (thisBtn.hasClass('gotoFBtn')) {
      console.log('gotoFBtn');
      gotoUrl =
        Model.urls.player + '?p=' + Model.parameters.projektId + '&t=f&k=';
      openLink = true;
    }
    if (thisBtn.hasClass('gotoEBtn')) {
      console.log('gotoEBtn');
      gotoUrl =
        Model.urls.player + '?p=' + Model.parameters.projektId + '&t=e&k=';
      openLink = true;
    }
    if (thisBtn.hasClass('editCourseBtn')) {
      console.log('editCourseBtn');
      gotoUrl =
        Model.urls.edit + '?pid=' + Model.parameters.projektId + '&kid=';
      openLink = true;
    }
    if (thisBtn.hasClass('linkBtn')) {
      console.log('linkBtn');
      openLink = false;
      let fieldToGet = thisBtn.parent().find('.linkDisplay');

      /* Select the text field */
      fieldToGet.select();

      /* Copy the text inside the text field */
      document.execCommand('copy');
      // console.log('urlToGet:' + JSON.stringify(urlToGet, null, '\t'));

      fieldToGet
        .tooltip({
          title: 'Linket er kopieret til udklipsholderen',
          html: true,
          delay: { show: 0, hide: 100 },
          animation: false,
        })
        .tooltip('show');

      thisBtn.tooltip('hide');
      fieldToGet.tooltip('disable');
      if (document.selection) document.selection.empty();
      else if (window.getSelection) window.getSelection().removeAllRanges();
      setTimeout(function() {
        fieldToGet.tooltip('hide');
      }, 3000);
    }

    if (openLink) {
      console.log('gotoUrl: ' + gotoUrl + kId);
      window.open(gotoUrl + kId, '_blank');
    }
  });
  $('#playerLink').click(function() {
    window.location.href =
      Model.urls.edit + '?pid=' + Model.parameters.projektId;
    console.log('Model:', Model);
  });
  $('.toTopBtn').click(function() {
    $(window).scrollTop(0);
  });
};
export default EventHandlers;
